import React, { Component } from "react";
import { translate } from "../../../utils/useful";
import DropHandles from "./DropHandlers";
import RowContent from "./RowContent";

class SingleRow extends Component {





    onDrop = (e, DRowID, DSectionId, DPageId, direction, inputIndex) => {
        e.preventDefault();
        let dragData;
        if (e.dataTransfer.getData) {
            dragData = e.dataTransfer.getData("dragData");
        }
        else {
            dragData = e.dataTransfer;
            dragData = JSON.stringify(dragData);
        }

        // 
        const { rowId, sectionId, pageId, dropType, type, inputId } = JSON.parse(dragData);

        if (dropType == "NEW") {
            // console.log('formContent224', direction)

            if (!direction) {
                // console.log('formContent225')
                // console.log("HERE1")
                this.props.addnewItem(type, DRowID, DSectionId, DPageId);
            }
            if (direction) {
                // console.log('formContent226')
                // console.log("HERE")
                this.props.addnewItem(type, DRowID, DSectionId, DPageId, direction, inputIndex);
            }
        }
        if (dropType == "CHANGE") {
            this.props.changeInputPosition(
                inputId,
                type,
                rowId,
                sectionId,
                pageId,
                DRowID,
                DSectionId,
                DPageId,
                direction,
                inputIndex
            );
            e.target.style.background = "rgb(168, 160, 160)";
        }
        this.props.setDisplayHandlers();
        this.props.hideHandlersFunc();
        this.rowRef.style.backgroundColor = "none";
        this.rowRef.style.border = "none";


    };
    onDragOver = (e, innerLine) => {
        e.preventDefault();
        if (this.props.rowContent == 0) {
            if (this.rowRef) {
                this.rowRef.style.border = "1px dahsed #6D79CC";
            }
            e.target.style.background = "rgb(245, 240, 240)";

            // this.dropText.style.backgroundColor = "red";
        } else {
            innerLine.style.visibility = 'hidden'
            if (this.rowRef) {
                this.rowRef.style.border = "rgb(245, 240, 240) !important";
            }
            e.target.style.background = "linear-gradient(to left, #6D79CC, #7D89dC )";
        }
    };

    onDragLeave = (e, innerLine) => {
        if (this.props.rowContent == 0) {
            // e.target.style.background = "rgb(245, 240, 240)";
            // this.rowRef.style.border = "1px dahsed transparent";
            e.target.style.background = "none";
            this.dropText.style.backgroundColor = "transparent";
        } else {
            if (innerLine && innerLine.style) {
                innerLine.style.visibility = 'visible'
            }
            e.target.style.background = "none";
        }
    };





    render() {
        const {
            formsRows,
            showhandlers,
            showhandlersFunc,
            hideHandlersFunc,
            rowId,
            rowContent,
            rowLength,
            rowIndex,
            deleteInput,
            displayHandlers,
            openInputConfig
        } = this.props;
        // const { displayHandlers } = this.state;
        const dropHandles = [
            { direction: "top", style: {} },
            { direction: "bottom", style: {} }
        ];

        return (
            <div
                ref={(el) => (this.rowRef = el)}
                key={rowId}
                className="form-row "
                onDragOver={(e) => !displayHandlers && this.onDragOver(e)}
                onDragLeave={(e) => !displayHandlers && this.onDragLeave(e)}
            >
                {/* {console.log('dlksj', rowContent)} */}
                <div className="row" style={{ width: "100%", display: 'flex', border: '1px solid transparent' }}>
                    {/* {console.log('rowContent =>>', rowContent)} */}
                    {rowContent.length > 0
                        ? rowContent.map((header, index) => {

                            const { id, type } = header;
                            return (
                                <RowContent
                                    inputClass={this.props.inputClass}
                                    formClass={this.props.formClass}
                                    header={header}
                                    showhandlers={showhandlers}
                                    displayHandlers={displayHandlers}
                                    showhandlersFunc={showhandlersFunc}
                                    hideHandlersFunc={hideHandlersFunc}
                                    openInputConfig={openInputConfig}
                                    index={index}
                                    key={id}
                                    inputId={id}
                                    rowId={rowId}
                                    sectionId={this.props.sectionId}
                                    setFormData={this.props.setFormData}
                                    pageId={this.props.pageId}
                                    type={type}
                                    rowLength={rowLength}
                                    onDrop={this.onDrop}
                                    onDragOver={this.onDragOver}
                                    onDragLeave={this.onDragLeave}
                                    deleteInput={deleteInput}

                                    setDisplayHandlers={this.props.setDisplayHandlers}
                                />
                            );
                        })
                        : (<div onDrop={(e) => rowContent.length == 0 && this.onDrop(e, rowId, this.props.sectionId, this.props.pageId)} onDragOver={(e) => this.onDragOver(e)} onDragLeave={(e) => this.onDragLeave(e)} className="drop-text text-center py-3 px-2 text-small" ref={(el) => (this.dropText = el)}>
                            {translate('Drop Here')}
                        </div>)}
                </div>
                {/* {rowContent.length == 0 ? (
                   
                ) : null} */}


                {showhandlers && rowContent.length > 0 ? (
                    <DropHandles
                        rowIndex={rowIndex}
                        onDrop={this.onDrop}
                        onDragOver={this.onDragOver}
                        onDragLeave={this.onDragLeave}
                        rowId={rowId}
                        sectionId={this.props.sectionId}
                        pageId={this.props.pageId}
                        dropHandles={dropHandles}
                        hideHandlersFunc={hideHandlersFunc}

                    />
                ) : (<div style={{ visibility: 'hidden' }}>
                    <DropHandles
                        rowIndex={rowIndex}
                        onDrop={this.onDrop}
                        onDragOver={(e) => this.onDragOver(e)}
                        onDragLeave={(e) => this.onDragLeave(e)}
                        rowId={rowId}
                        sectionId={this.props.sectionId}
                        pageId={this.props.pageId}
                        dropHandles={dropHandles}
                        hideHandlersFunc={hideHandlersFunc}

                    />
                </div>)}
            </div>
        );
    }
}

export default SingleRow;